import React, { forwardRef } from 'react';
import classNames from 'classnames';
import CarbonSidebar, { SidebarProps as CarbonSidebarProps } from 'carbon-react/lib/components/sidebar';

import * as styles from './carbon-sidebar.scss';

export type SidebarProps = CarbonSidebarProps;

/**
 * Thin wrapper around carbon-react's Sidebar.
 *
 * After the carbon-react upgrade, Sidebar no longer has a grey background by default like it
 * used to. This wrapper transports all props straight through to carbon's Sidebar, only adding
 * its own className to restore that background, so we get design parity with the previous
 * carbon-react version without every consumer needing to set it individually.
 */
export const Sidebar = forwardRef<HTMLDivElement, SidebarProps>(({ className, ...props }, ref) => (
  <CarbonSidebar ref={ref} className={classNames(styles.sidebar, className)} {...props} />
));

Sidebar.displayName = 'Sidebar';

export default Sidebar;
